import {
  type AvatarProps,
  type IconButtonProps,
  Avatar,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import type * as React from 'react'

import { PxSuperuserDetail } from '@ifca-ui/icons/src'
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { RowFlex } from '../Layout/LayoutX/Flex/RowFlex'

const ProfileContainer = styled('div')`
  /* background-size: 100% 100% !important; */
  background: ${(props: ProfileSectionProps) =>
    props.drawerImage ? `url("${props.drawerImage}")` : '#f5f5f5'};
`
const AvatarSection = styled(Box)`
  padding: 20px 16px 30px;
  margin: 0;
  border-radius: unset;
  .MuiAvatar-colorDefault {
    color: #fafafa;
    background-color: #212121 !important;
  }
  .avatar {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 100%;
  }
`
const StyledAvatar = styled(Avatar)`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 100%;
`
const StyledList = styled(List)`
  padding: 0px;
  background: #00000075;
  .MuiListItem-root {
    padding: 8px 48px 8px 16px;

    .MuiListItemText-root {
      margin: 0px;
      .MuiTypography-root {
        display: flex;
        color: #fff;
      }
    }
  }
  .MuiIconButton-root {
    color: #fff;
  }
`

export interface ProfileSectionProps {
  drawerImage?: string
  avatar?: AvatarProps
  profile?: {
    title?: string
    subTitle?: string
    superUser?: boolean
  }
  dropDownIcon?: IconButtonProps
}
export const ProfileSection: React.FC<ProfileSectionProps> = ({
  drawerImage,
  avatar,
  profile,
  dropDownIcon,
}) => {
  return (
    <ProfileContainer drawerImage={drawerImage}>
      <AvatarSection>
        <StyledAvatar {...avatar} />
      </AvatarSection>
      <StyledList disablePadding>
        <ListItem>
          <ListItemText
            primary={
              <RowFlex mainAxisAlignment="space-between" fullWidth>
                <Typography
                  component="span"
                  variant="inherit"
                  className="text-smTitle"
                >
                  {profile?.title}
                </Typography>
                {profile?.superUser && (
                  <PxSuperuserDetail height="15px" width="15px" />
                )}
              </RowFlex>
            }
            secondary={
              <Typography
                component="span"
                variant="inherit"
                className="text-desc"
              >
                {profile?.subTitle}
              </Typography>
            }
          />
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="simple-menu" {...dropDownIcon}>
              <ExpandMoreIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </StyledList>
    </ProfileContainer>
  )
}
